/**
 * Shared table styles for markdown-rendered tables.
 * Used by AnalystReportSection and ReviewPage.
 * 
 * Supports all four theme combinations:
 * - default + light
 * - default + dark
 * - summit + light
 * - summit + dark
 */

export function getTableStyles(isDark, isSummit) {
  // Colour palette based on theme/mode
  const colors = isDark
    ? isSummit
      ? { // Summit + Dark
          headerBg: '#1a0040',
          headerText: '#e2d4ff',
          headerBorder: '#3d2a6e',
          rowAltBg: '#120030',
          border: '#2d1a5e',
          outerBorder: '#3d2a6e',
          text: '#e2e8f0',
        }
      : { // Default + Dark
          headerBg: '#1a2332',
          headerText: '#e2e8f0',
          headerBorder: '#475569',
          rowAltBg: '#1e293b',
          border: '#334155',
          outerBorder: '#475569',
          text: '#cbd5e1',
        }
    : isSummit
      ? { // Summit + Light
          headerBg: '#f0ecff',
          headerText: '#250070',
          headerBorder: '#b8a8e0',
          rowAltBg: '#f8f5ff',
          border: '#d4c8f0',
          outerBorder: '#b8a8e0',
          text: '#1a1a2e',
        }
      : { // Default + Light
          headerBg: '#f2f3f3',
          headerText: '#232f3e',
          headerBorder: '#d1d5db',
          rowAltBg: '#fafafa',
          border: '#e9ebed',
          outerBorder: '#d1d5db',
          text: '#16191f',
        };

  return {
    wrapper: {
      overflowX: 'auto',
      margin: '16px 0',
      borderRadius: '6px',
      border: `1px solid ${colors.outerBorder}`,
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse',
      fontSize: '0.9rem',
      lineHeight: '1.5',
    },
    thead: {
      backgroundColor: colors.headerBg,
    },
    th: {
      textAlign: 'left',
      padding: '10px 14px',
      fontWeight: 600,
      fontSize: '0.85rem',
      color: colors.headerText,
      borderBottom: `2px solid ${colors.headerBorder}`,
      whiteSpace: 'nowrap',
    },
    td: {
      padding: '8px 14px',
      borderBottom: `1px solid ${colors.border}`,
      color: colors.text,
      verticalAlign: 'top',
    },
    tdNumeric: {
      padding: '8px 14px',
      borderBottom: `1px solid ${colors.border}`,
      color: colors.text,
      verticalAlign: 'top',
      textAlign: 'right',
      fontVariantNumeric: 'tabular-nums',
    },
    trAlt: {
      backgroundColor: colors.rowAltBg,
    },
  };
}
